export default __webpack_public_path__ + "static/media/logo-placeholder.0a2b9a16.svg";